import { forwardRef, Ref, type SVGProps } from 'react';

const SvgGlobeIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#globe-icon_svg__a)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m2.563 6.236 3.574 2.552c.186.133.279.2.376.215.086.013.173 0 .25-.04.089-.043.157-.135.295-.317l.755-1.007a1 1 0 0 1 .08-.1.4.4 0 0 1 .067-.053c.027-.017.056-.03.115-.056L11.3 5.997c.134-.06.2-.09.25-.136a.4.4 0 0 0 .104-.147c.026-.063.03-.136.04-.282l.237-3.54m-.68 9.358 2.18.934c.253.109.38.163.446.253a.42.42 0 0 1 .082.274c-.007.112-.083.227-.236.456l-1.024 1.536a1 1 0 0 1-.156.202.4.4 0 0 1-.144.077c-.06.018-.124.018-.255.018H10.48c-.172 0-.259 0-.332-.029a.4.4 0 0 1-.167-.12c-.051-.061-.078-.143-.133-.307l-.594-1.782a1 1 0 0 1-.053-.194.4.4 0 0 1 .01-.13c.01-.048.034-.094.08-.185l.45-.902c.092-.184.138-.276.209-.333a.4.4 0 0 1 .217-.09c.09-.01.187.023.382.088zM18.333 10a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0"
      />
    </g>
    <defs>
      <clipPath id="globe-icon_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgGlobeIcon);
export default ForwardRef;
